import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StoreService } from '../store/store.service';

export const hasPermission: CanActivateFn = () => {
  const store = inject(StoreService);
  const router = inject(Router);

  const { roles } = store.getStore().getState().auth;
  const hasRole = roles.some((role) => role === 'Versorgungsmanager');
  if (!hasRole) {
    router.navigate(['auth']);
    return false;
  }
  return true;
};
